import './Services.css';

function Services() {
  return (
    <section id="servicios" className="services-section py-5">
      <div className="container">

        {/* Título */}
        <div className="text-center mb-5 animate-on-scroll">
          <h6 className="text-primary text-uppercase">NUESTROS SERVICIOS</h6>
          <h2 className="fw-bold">¿Cómo <span className="text-primary">podemos ayudarte?</span></h2>
          <p className="text-muted fs-5 w-75 mx-auto">
            En <strong>Code Nest</strong> transformamos tus ideas en soluciones digitales reales. Descubre lo que podemos crear para ti.
          </p>
        </div>

        {/* Tarjetas de Servicios */}
        <div className="row text-center">
          
          <div className="col-md-4 mb-4 animate-on-scroll">
            <div className="p-4 shadow-sm bg-white rounded h-100">
              <i className="bi bi-laptop display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">Páginas Web Profesionales</h5>
              <p>Desarrollamos sitios web modernos, adaptados a cualquier dispositivo y enfocados en generar resultados para tu negocio.</p>
            </div>
          </div>

          <div className="col-md-4 mb-4 animate-on-scroll">
            <div className="p-4 shadow-sm bg-white rounded h-100">
              <i className="bi bi-phone display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">Aplicaciones Móviles</h5>
              <p>Creamos apps a medida para Android y iOS que te permiten conectar con tus clientes y mejorar su experiencia.</p>
            </div>
          </div>

          <div className="col-md-4 mb-4 animate-on-scroll">
            <div className="p-4 shadow-sm bg-white rounded h-100">
              <i className="bi bi-server display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">Sistemas y Plataformas</h5>
              <p>Desarrollamos sistemas personalizados que automatizan procesos y optimizan la gestión de tu empresa.</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Services;
